import { render, staticRenderFns } from "./MenuBarFavorites.vue?vue&type=template&id=07f25002"
import script from "./MenuBarFavorites.vue?vue&type=script&lang=js"
export * from "./MenuBarFavorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports